import amb from '../../../assets/icons/amb.svg';
import React from 'react';
import { BigNumber } from 'ethers';
import useMarkets from '../../../contexts/MarketsContext/useMarkets';
import { MarketContextType } from '../../../contexts/MarketsContext/provider.interface';
import { getTokenByAddress } from '../../../utils/getTokenByAddress';
import { vestingOptions } from '../../../utils/constants';
import { timestampToDate } from '../../../utils/timestampToDate';
import { displayAmount, formatDecimals } from '../../../utils/formatDecimals';

type ConfirmModalProps = {
  tokenAddress: string;
  capacity: string;
  vesting: number;
  quoteTokenName: string | undefined;
  price: number | undefined;
  vestingExpired?: any;
  quoteToken: string;
};

const ConfirmModal = (props: ConfirmModalProps) => {
  const { tokens }: MarketContextType = useMarkets();
  const vestingLabel = vestingOptions.find(
    el => el.value === props.vesting,
  )?.label;

  const payoutTokenData = getTokenByAddress(props.tokenAddress, tokens);

  return (
    <>
      <div className="review-item">
        <p className="review-item__title">Payout tokens</p>
        <div className="review-item__answer-container">
          <img
            src={payoutTokenData?.logoUrl}
            alt="coin"
            className="review-item__logo"
          />
          <p className="review-item__token">
            {(+props.capacity).toLocaleString()}
          </p>
          <p className="review-item__token__grey">
            ${(+props.capacity * (payoutTokenData?.price || 0)).toFixed(2)}
          </p>
        </div>
      </div>
      <div className="review-item">
        <p className="review-item__title">
          {props.vestingExpired ? 'Vesting expired' : 'Vesting length'}
        </p>
        <div className="review-item__answer-container-end">
          <p className="review-item__answer-text">
            {props.vestingExpired
              ? timestampToDate(new Date(props.vestingExpired).getTime() / 1000)
              : vestingLabel}
          </p>
        </div>
      </div>
      <div className="review-item">
        <p className="review-item__title">Quote token</p>
        <div className="review-item__answer-container-end">
          <p className="review-item__answer-text">
            {props.quoteTokenName?.toUpperCase()}
          </p>
        </div>
      </div>
      <div className="review-item">
        <p className="review-item__title">Price</p>
        <div className="review-item__answer-container-end">
          <p className="review-item__answer-text">
            {props.price ? `$${displayAmount(props.price, 5)}` : '-'}
          </p>
        </div>
      </div>
    </>
  );
};

export default ConfirmModal;
